import { useQuery } from '@tanstack/react-query';
import ContractTemplateService, {
  IContractTemplateParagraph,
} from '@clickersphere/core/services/ContractTemplateService';
import { useBuildQueryKey } from '../useBuildQueryKey';

export const CONTRACT_TEMPLATE_PARAGRAPHS_QUERY_KEY =
  'contract-template-paragraphs';

interface IUseContractTemplateParagraphsOptions {
  enabled?: boolean;
}

export function useContractTemplateParagraphs(
  templateId: string | undefined,
  options?: IUseContractTemplateParagraphsOptions,
) {
  const { buildQueryKey } = useBuildQueryKey();

  const { data, isLoading, isFetching, isSuccess } = useQuery({
    staleTime: 1000 * 60 * 5,
    enabled: !!templateId && (options?.enabled ?? true),
    queryKey: buildQueryKey([
      CONTRACT_TEMPLATE_PARAGRAPHS_QUERY_KEY,
      templateId,
    ]),
    queryFn: async () => {
      const result = await ContractTemplateService.getParagraphs(
        templateId as string,
      );
      return result.paragraphs;
    },
  });

  return {
    paragraphs: (data ?? []) as IContractTemplateParagraph[],
    isParagraphsLoading: isLoading,
    isParagraphsFetching: isFetching,
    isParagraphsSuccess: isSuccess,
  };
}
